export default "__VITE_ASSET__XMWEFK9P__"